// src/components/Admin/Auth/Auth.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  RegisterFormPartner,
  LoginFormPartner,
} from "../../../components/Admin/AuthPartner"; // mismo barrel
import { LanguageSwitcher } from "../../../components/Admin/AdminLayout/LanguageSwitcher";
import { logoEduca } from "../../../assets";
import "./AuthPartner.scss";

export function AuthPartner() {
  const [isLogin, setIsLogin] = useState(true);
  const { t } = useTranslation("auth");

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Logo de Educa360 */}
        <img src={logoEduca.logoE360} alt="Educa360" className="auth-logo" />

        {/* Language switcher */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginBottom: 8,
          }}
        >
          <LanguageSwitcher />
        </div>

        {/* Aquí pasamos openLogin al RegisterForm */}
        {isLogin ? (
          <LoginFormPartner />
        ) : (
          <RegisterFormPartner openLogin={() => setIsLogin(true)} />
        )}

        {/* Link para cambiar entre Login y Sign Up */}
        <div className="auth-switch">
          {isLogin ? (
            <>
              {t("auth.noAccountPartner")}{" "}
              <button
                type="button"
                className="link-btn"
                onClick={() => setIsLogin(false)}
              >
                {t("auth.createAccount")}
              </button>
            </>
          ) : (
            <>
              {t("auth.haveAccountPartner")}{" "}
              <button
                type="button"
                className="link-btn"
                onClick={() => setIsLogin(true)}
              >
                {t("auth.signIn")}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
